import { useStore } from '@/core'
import { ModalConfirm } from '@/core/components/modal-confirm'
import { useTranslation } from 'react-i18next'

export const CompanyDoesNotExistModal = () => {
  const { t } = useTranslation()
  const store = useStore()
  return (
    <ModalConfirm
      name="company-does-not-exist"
      message={t('onboardingPage.companyDoesNotExistModal.title')}
      info={
        <span>{t('onboardingPage.companyDoesNotExistModal.message')}</span>
      }
      confirm={t('onboardingPage.companyDoesNotExistModal.buttons.confirm')}
      cancel={t('onboardingPage.companyDoesNotExistModal.buttons.cancel')}
      onClickCancel={(ev) => {
        ev.preventDefault()
        store.set(['modal'], null)
      }}
      form={{
        name: 'ConfirmModal',
        onSubmit: async () => {
          store.set(['modal'], null)
          window.open('https://meetings.hubspot.com/eric-franzo/purposely-demo', '_blank')
        },
      }}
    />
  )
}
